import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const OVERLAYS = {
  dark: "chapter-overlay chapter-overlay-dark",
  left: "chapter-overlay chapter-overlay-left",
  right: "chapter-overlay chapter-overlay-right",
  center: "chapter-overlay chapter-overlay-center",
};

// Full-viewport cinematic chapter: photo background with slow parallax + zoom tied to scroll.
export default function Chapter({ img, overlay = "dark", className = "", innerClassName = "", testId, children }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.18, 1.02]);

  return (
    <section ref={ref} className={`chapter ${className}`} data-testid={testId}>
      <div className="chapter-bg" aria-hidden>
        <motion.div
          className="chapter-img"
          style={{ backgroundImage: `url(${img})`, y: reduce ? 0 : y, scale: reduce ? 1 : scale }}
        />
      </div>
      <div className={OVERLAYS[overlay] || OVERLAYS.dark} aria-hidden data-overlay={overlay} />
      <div className="grain absolute inset-0" aria-hidden />
      <div className={`chapter-content container-gaza w-full py-28 md:py-36 ${innerClassName}`}>{children}</div>
    </section>
  );
}
